/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { HeaderStyles } from './headerStyles';
import Legend from './legend';

export default function Header() {
  return (
    <HeaderStyles>
      <h2 className="headline">
        Explosions and remote attacks by Israeli forces in Lebanon
      </h2>
      <p>
        This interactive map shows conflict events in Lebanon, limited to
        incidents involving Israeli military forces and classified as explosions
        or remote violence.
        <br />
        <strong>Click on the markers to see details of each event.</strong>
      </p>
      <Legend />
    </HeaderStyles>
  );
}
